import { useState } from 'react';
import { Upload, X } from 'lucide-react';
import { Input } from '@/components/ui/input';

const NoticeForm = ({ onSubmit, onCancel }) => {
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [category, setCategory] = useState('Circular');
  const [date, setDate] = useState(new Date().toISOString().split('T')[0]);
  const [file, setFile] = useState(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({ title, description, category, date, file_url: file ? URL.createObjectURL(file) : null });
    setTitle('');
    setDescription('');
    setFile(null);
  };

  return (
    <form onSubmit={handleSubmit} className="border-2 border-[#C4A35A] bg-white p-6 mb-6" data-testid="notice-form">
      <div className="flex items-center justify-between mb-5">
        <h3 className="text-[10px] font-bold uppercase tracking-wider text-[#9B9589]">New Notice</h3>
        <button type="button" onClick={onCancel} className="text-[#9B9589] hover:text-[#0F1B2D]"><X size={16} /></button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        <div>
          <label className="text-[10px] uppercase tracking-[0.2em] text-[#9B9589] font-bold block mb-2">Title</label>
          <Input type="text" value={title} onChange={(e) => setTitle(e.target.value)} className="input-ainaa" placeholder="Notice title" required data-testid="notice-title-input" />
        </div>
        <div className="flex gap-4">
          <div className="flex-1">
            <label className="text-[10px] uppercase tracking-[0.2em] text-[#9B9589] font-bold block mb-2">Category</label>
            <select value={category} onChange={(e) => setCategory(e.target.value)} className="input-ainaa w-full h-10 text-sm" data-testid="notice-category">
              <option value="Circular">Circular</option>
              <option value="Advisory">Advisory</option>
              <option value="Notice">Notice</option>
              <option value="Amendment">Amendment</option>
            </select>
          </div>
          <div className="flex-1">
            <label className="text-[10px] uppercase tracking-[0.2em] text-[#9B9589] font-bold block mb-2">Date</label>
            <Input type="date" value={date} onChange={(e) => setDate(e.target.value)} className="input-ainaa" data-testid="notice-date-input" />
          </div>
        </div>
      </div>
      <div className="mb-4">
        <label className="text-[10px] uppercase tracking-[0.2em] text-[#9B9589] font-bold block mb-2">Description</label>
        <textarea value={description} onChange={(e) => setDescription(e.target.value)} className="input-ainaa w-full min-h-[80px] text-sm resize-none p-3" placeholder="Notice content" required data-testid="notice-desc-input" />
      </div>
      <div className="flex items-center gap-4 mb-4">
        <label className="flex items-center gap-2 cursor-pointer text-xs font-medium text-[#9B9589] hover:text-[#0F1B2D] border border-[#D8D3CB] px-3 py-2">
          <Upload size={14} />{file ? file.name : 'Attach File (optional)'}
          <input type="file" className="hidden" onChange={(e) => setFile(e.target.files[0])} data-testid="notice-file-input" />
        </label>
      </div>
      <button type="submit" className="btn-ainaa-primary px-6 py-2.5 text-xs font-semibold uppercase tracking-wider" data-testid="notice-submit-btn">Publish Notice</button>
    </form>
  );
};

export default NoticeForm;
